import React from "react";
import { TextField } from "@mui/material";
import PhoneInput from "react-phone-number-input";

const PhoneNumberFieldForObjectState = ({ formInfo, Object, handleChange }) => {
  const inputProps = {
    style: {
      backgroundColor: "white",
      textAlign: "left",
      color: "black", // Set the font color to black
    },
  };

  const inputLabelProps = {
    style: {
      fontSize: "1.2rem", // Increase the font size of the label
      color: "black", // Set the label color to black
    },
    shrink: true,
  };

  let label = Object.label;
  let name = Object.name;

  let AboveText = Object.AboveText;

  return (
    <div>
      {window.innerWidth >= 800 ? (
        <div style={{ fontSize: "1.2rem", color: "black" }}>{AboveText}</div>
      ) : (
        <div style={{ fontSize: "1.2rem", color: "black" }}>
          {AboveText}
          <br></br>
          <i>{label}:</i>
        </div>
      )}
      <PhoneInput
        // flagUrl="http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
        className="Phone"
        placeholder="Enter phone number"
        label={window.innerWidth >= 800 ? label : ""}
        name={name}
        variant="outlined"
        fullWidth
        required
        value={formInfo && formInfo[name] ? formInfo[name] : ""}
        onChange={handleChange}
      />
      <br></br>
    </div>
  );
};

export default PhoneNumberFieldForObjectState;
